// extracted by mini-css-extract-plugin
export default {"shipping-country-flag":"shipping-country-flag--awFdJ","shippingCountryFlag":"shipping-country-flag--awFdJ"};